import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import testmonial1 from "../../assets/Testmonial/Testmonial1.jpg";
import testmonial2 from "../../assets/Testmonial/Testmonial2.jpg";
import testmonial3 from "../../assets/Testmonial/Testmonial3.jpg";
import testmonial4 from "../../assets/Testmonial/Testmonial4.jpg";
import testmonial5 from "../../assets/Testmonial/Testmonial5.jpg";

const Testmonials = () => {
    const testimonials = [
        {
          id: 1,
          avatar: testmonial1,
          quote: "Super service. They did a neat and superb job. They even give you the choice of colour of the wire. Silent excellent workers... Highly recommended them.",
          author: "Muthu Ganesh",
          rating: 5,
        },
        {
          id: 2,
          avatar: testmonial2,
          quote: "Excellent work, very neat and professional, will surely refer to other people. Also thanks to Saravanan for being punctual, patient and amicable.",
          author: "Rama Soundararaajan",
          rating: 5,
        },
        {
          id: 3,
          avatar: testmonial3,
          quote: "Very happy with the work done. We gave a sofa set and a chair for cane weaving and the work done is impeccable. Strongly recommended if you are looking for original cane weaving work in Chennai.",
          author: "Sandeepthi Palukuri",
          rating: 5,
        },
        {
          id: 4,
          avatar: testmonial4,
          quote: "Very reliable and was committed to completing work. Was enthusiastic to take up this job as well. Need to support artisans like Mr. Shankar who has learnt this skill from his great grandparents.",
          author: "Abirami Vilvanathan",
          rating: 5,
        },
        {
          id: 5,
          avatar: testmonial5,
          quote: "Great quality of work from Mr. Shankar. Done a great job with perfection within the committed time frame. Fixed all my chairs. Looks fabulous now.",
          author: "Selva Kumar",
          rating: 5,
        },
      ];
    
      const [selected, setSelected] = useState(testimonials[0]);

      return (
        <section className="bg-charcoal text-linen py-20 md:py-32 px-6">
            <div className="max-w-5xl mx-auto flex flex-col items-center">
                
                {/* Header */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-brass uppercase tracking-[0.2em] text-xs font-semibold block mb-4">
                        Patron Experiences
                    </span>
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light">
                        Voices of Heritage
                    </h2>
                </motion.div>

                {/* Main Quote Area */}
                <div className="w-full min-h-[300px] md:min-h-[250px] flex flex-col items-center justify-center relative">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={selected.id}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                            className="text-center flex flex-col items-center w-full"
                        >
                            {/* SVG Quote Icon */}
                            <svg className="w-10 h-10 text-brass/40 mb-6" fill="currentColor" viewBox="0 0 32 32">
                                <path d="M10 8c-3.3 0-6 2.7-6 6v10h10V14H8.6c.8-2.3 3-4 5.4-4h2V8h-6zm16 0c-3.3 0-6 2.7-6 6v10h10V14h-5.4c.8-2.3 3-4 5.4-4h2V8h-6z" />
                            </svg>

                            <p className="font-serif italic text-xl sm:text-2xl md:text-3xl lg:text-4xl leading-relaxed text-linen/90 max-w-4xl cursor-default">
                                "{selected.quote}"
                            </p>

                            <div className="mt-10 flex flex-col items-center gap-3">
                                <h4 className="uppercase tracking-[0.15em] text-xs font-semibold text-brass">
                                    {selected.author}
                                </h4>
                                <div className="flex gap-1 text-brass">
                                    {[...Array(selected.rating)].map((_, index) => (
                                        <svg key={index} className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                                            <path d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.785 1.401 8.162L12 18.902l-7.335 3.855 1.401-8.162-5.934-5.785 8.2-1.192L12 .587z" />
                                        </svg>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>

                {/* Avatar Selectors */}
                <div className="mt-16 flex justify-center flex-wrap gap-4 md:gap-6 relative z-10">
                    {testimonials.map((testimonial) => (
                        <button
                            key={testimonial.id}
                            onClick={() => setSelected(testimonial)}
                            className="relative focus:outline-none group overflow-hidden rounded-full transition-transform duration-300"
                        >
                            <img
                                src={testimonial.avatar}
                                alt={`Review by ${testimonial.author}`}
                                className={`w-14 h-14 md:w-16 md:h-16 object-cover rounded-full transition-all duration-500 border-2 ${
                                    selected.id === testimonial.id
                                        ? "border-brass scale-110 filter hover:grayscale-0"
                                        : "border-transparent opacity-60 grayscale scale-100 hover:scale-105 hover:grayscale-0 hover:opacity-100"
                                }`}
                            />
                        </button>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Testmonials;